import { GroupMembershipDialogCtrl, IGroupMembershipDialogScope } from '../controllers/GroupMembershipDialogCtrl';
import { IActionContext } from '../helpers/ActionContext';
import { ISiteUserInfo } from '../models/ISiteUserInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ModalService, ModalSize } from './ModalService';

export class EditGroupMembershipAction {

  public static $inject = ['ModalService'];

  constructor(private modalService: ModalService) { }

  // TODO: use ConfimActionDialog
  public showEditGroupMembershipDialog(
    users: Set<ISiteUserInfo>,
    context: IActionContext): ng.IPromise<any> {

    const scope = <IGroupMembershipDialogScope> context.scope.$new(true);
    scope.users = users;

    const dialogInstance = this.modalService.open({
      scope: scope,
      templateUrl: 'groupMembershipDialog.html',
      size: ModalSize.fitToContent,
      controller: GroupMembershipDialogCtrl
    });

    return dialogInstance.result.finally(() => scope.$destroy());
  }

}

Module.instance().service('EditGroupMembershipAction', EditGroupMembershipAction);
